<template>
    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1050;">
      <div v-if="visible" :class="alertClass" role="alert">
        <strong>{{ alertTitle }}</strong> {{ message }}
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, watch, computed, defineProps } from 'vue';
  
  const props = defineProps({
    show: Boolean,
    duration: {
      type: Number,
      default: 5000
    },
    message: {
      type: String,
      default: 'This is a warning alert that will fade out.'
    },
    alertType: {
      type: String,
      default: 'warning'
    }
  });
  
  const visible = ref(props.show);
  
  watch(() => props.show, (newVal) => {
    if (newVal) {
      visible.value = true;
      setTimeout(() => {
        visible.value = false;
      }, props.duration);
    }
  });
  
  const alertClass = computed(() => {
    return `alert alert-${props.alertType} alert-dismissible fade show`;
  });
  
  const alertTitle = computed(() => {
    switch (props.alertType) {
      case 'success':
        return 'Success!';
      case 'danger':
        return 'Danger!';
      case 'info':
        return 'Info!';
      case 'warning':
      default:
        return 'Warning!';
    }
  });

  const message = computed(() => {
    return props.message;
  });
  </script>
  
  <style scoped>
  /* Additional styles if needed */
  </style>
  